import { APIDataThreadMessage, APIMetaDataThreadMessagePropertyNames } from '@evertel/types'
import { Store } from '@evertel/types'
import { decorate, injectable } from '@evertel/di'

export interface DisplayThreadMessage extends APIDataThreadMessage {
    prevMessageDate?: Date
    prevOwnerId?: number
    dateChanged?: boolean
    window?: 'primary' | 'anchor'
}

class ThreadMessagesStore extends Store<DisplayThreadMessage> {
    constructor() {
        super([...APIMetaDataThreadMessagePropertyNames, 'media', 'reactions', 'prevMessageDate', 'prevOwnerId', 'dateChanged', 'window'])
    }
}

decorate(injectable(), ThreadMessagesStore)

export { ThreadMessagesStore }
